import axios from '../..';

export const fetchAllNotification = () => axios.get(`api/notification/all`);

export const markAllAsReadNotification = () =>
  axios.patch(`api/notification/mark-all-as-read`);

export const markAsReadNotification = notificationId =>
  axios.patch(`api/notification/mark-as-read/${notificationId}`);
